/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

// Importing styles compiled from SCSS
import getBootstrapStyles from './bootstrap/scss/bootstrap.css';
import getBootstrapVariables from './bootstrap/scss/_variables.css';
import baseStyles from './_base.css';
import cardStyles from './_cards.css';
import clockStyles from './_clock.css';
import componentStyles from './components/_components.css';
import fieldsStyles from './fields/_fields.css';
import formGridsStyles from './form_grids/_grids.css';
import formClientsTabsStyles from './_formclientstabs.css';
import formDetailsStyles from './_formdetails.css';
import formEditorStyles from './_formEditor.css';
import formErrorsStyles from './_formerrors.css';
import formStyle from './_formstyle.css';
import formTabsStyles from './_formtabs.css';
import iconStyles from './_icons.css';
import mainContainerStyles from './_main-container.css';
import messageViewStyles from './_messageview.css';
import mobileStyles from './mobile.css';
import modalStyles from './_modals.css';
import navbarStyles from './_navbar.css';
import pdfViewerStyles from './_pdf-viewer.css';
import sidebarStyles from './_sidebar.css';
import schedulerStyles from './_scheduler.css';
import stampAcrossStyles from './_stamp-across.css';
import systemSettingsStyles from './_systemsettings.css';
import diagramStyles from './_diagram.css';
import uweStyles from './_uwestyles.css';

import tableStyles from './_tables.css';
import themeEditorStyles from './_themeeditor.css';
import userNavDropdownStyles from './_user-nav-dropdown.css';
import uweEntityStyles from './_uweentity.css';

import getUweEntityFormNavPanelStyles from './_uweentityformnavpanel.css';
import getVersionTagStyles from './_versiontag.css';
import getWelcomeBoxStyles from './_welcomebox.css';
import getWorkTrayStyles from './_worktray.css';
import getVariables from './_variables.css';
import getBlocklyEditorStyles from './_blocklyeditor.css';
import getJsonEditorStyles from './_jsoneditor.css';

const styles = [
  getBootstrapStyles,
  baseStyles,
  cardStyles,
  clockStyles,
  componentStyles,
  fieldsStyles,
  formGridsStyles,
  formClientsTabsStyles,
  formDetailsStyles,
  formEditorStyles,
  formErrorsStyles,
  formStyle,
  formTabsStyles,
  iconStyles,
  mainContainerStyles,
  messageViewStyles,
  mobileStyles,
  modalStyles,
  navbarStyles,
  pdfViewerStyles,
  sidebarStyles,
  schedulerStyles,
  stampAcrossStyles,
  systemSettingsStyles,
  tableStyles,
  themeEditorStyles,
  userNavDropdownStyles,
  uweEntityStyles,
  getUweEntityFormNavPanelStyles,
  getVersionTagStyles,
  getWelcomeBoxStyles,
  getWorkTrayStyles,
  diagramStyles,
  getJsonEditorStyles,
  getBlocklyEditorStyles,
  uweStyles,
];

export default $ => {
  return css(styles.map(style => style($)));
};
